export default __webpack_public_path__ + "static/media/05.5856b84a.jpeg";